import React, { Component } from 'react';
import { WidgetTypes, QuestionTypes } from '../../constants/QuestionTypes';
import {
	getDT,
	getForm,
	getFormWidgets,
	getFormWidgetQuestionsAnswers,
	getInfoConfigShared,
	getIdentifier,
	saveResponse,
	getRowColumns,
	customValidateForm,
	getQuestionTypes,
	getFormData,
	getFormDataElements,
	getFormClientSideValidation,
	getRandomizedResultFullScale,
	updateMDHParticipantInfo,
	saveSurveyResponseWithMDH
} from '../../services/formService';
import { getUserProjects } from '../../services/projectService';
import CustomLoader from '../common/Loader';
import { toaster, Custom_Forms } from '../../config';
import WidgetViewer from './Viewer/WidgetViewer';
import _, { forEach, split } from 'lodash';
import {logActivity, execGenericSP, executeSP} from "../../services/utilService";

import {getDataSources} from "../../services/dataSourceService";
import queryString from 'query-string';
import {BASE_URL} from "../../auth/authConfig";
import ScrollButton from '../common/ScrollButton';
import { stripTags, isNullOrEmpty } from '../common/commonFuncs';
import {FormTypes} from "../../constants/FormTypes";

import ErrorPopup from "../common/ErrorPopup"

class FormViewer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			Form_ID: this.props.Form_ID ? this.props.Form_ID : 0,
			Form_Name: '',
			Widgets: [],
			LightMode: this.props.LightMode ? true : false,
			PreviewMode: this.props.PreviewMode ? true : false,
			SurveyMode: this.props.SurveyMode ? this.props.SurveyMode : false,
			PrimaryKey: this.props.PrimaryKey ? this.props.PrimaryKey : queryString.parse(window.location.search).pk || '',
			Project_ID: this.props.Project_ID ? this.props.Project_ID : 0,
			Responses: {},
			loading: true,
			DataTableWidget: {},
			ParametersList: [],
			FilterParametersList: [],
			selectedInst: queryString.parse(window.location.search).inst_id ? queryString.parse(window.location.search).inst_id : this.props.selectedInst,
			isTab: this.props.isTab ? this.props.isTab : false,
			isPopUp : this.props.isPopUp ? this.props.isPopUp : false,
			isValid : false,
			showWarningModal: false,
			warningModalMessage: '',
			clearForm: false,
			defaultRender : false,
			rulesObj : [],
			Form_SecondaryIDValue: this.props.Form_SecondaryIDValue || 0,
			Form_SecondaryIDName: this.props.Form_SecondaryIDName || '',
			questionSequence: [],
			dataElements: [],
			rules : [],
			isViewOnly: this.props.isViewOnly || false,
			refreshWidget: false,
			mdhUpdateWidgets: [], // stores MDH widgets that have fields that need to be updated in MDH upon form save
			allowSavingForm: {},
			alertMessages: [],
			isParticipantRandomized: false
		};
		this.handleCancel = this.handleCancel.bind(this)
	}

	async componentDidMount() {
		let {data} = await getRandomizedResultFullScale(this.state.PrimaryKey)
		this.setState({isParticipantRandomized: 'Treatment' in data})

		let Widgets = this.props.Widgets ? this.props.Widgets : [],
			Form_ID = (this.props.history && queryString.parse(this.props.history.location.search).form_id ) ? queryString.parse(this.props.history.location.search).form_id : this.props.Form_ID,
			Project_ID=(this.props.history && queryString.parse(this.props.history.location.search).project_id ) ? queryString.parse(this.props.history.location.search).project_id : this.props.Project_ID;
		
		//Preview Mode
		if (this.state.PreviewMode) {
			let params = queryString.parse(window.location.search)
			Form_ID = params.Form_ID
			Project_ID = params.Project_ID
		}

		if (Form_ID === undefined) {
			const { data: projects } = await getUserProjects();
			const queryParameters = queryString.parse(this.props.location.search)
			this.setState({ projects });
			if (typeof projects === 'string') {
				console.error('No institutions assigned to user')
				this.setState({ error: true });
			}
			else if (!_.isEmpty(queryParameters) && (queryParameters.project_id) && !(queryParameters.form_id) ) {
				const projectSelected = _(projects).find(obj => obj.Project_ID === parseInt((queryParameters.project_id)));
				Form_ID = projectSelected ? projectSelected['MPOG_Link_Form_ID'] : -2
				Project_ID=projectSelected['Project_ID']
			}
			else if (!_.isEmpty(queryParameters) && (queryParameters.form_id)) {
				Form_ID = queryParameters.form_id
				Project_ID=queryParameters.project_id
			}
			else if (projects.length > 0) {
				Form_ID = projects[0]['MPOG_Link_Form_ID']
				Project_ID= projects[0]['Project_ID']
			}
			else {
				window.location.reload();
			}
		}

		if (!this.state.PreviewMode) {
			// GET FORM PROPERTIES
			let { data: form } = await getForm(parseInt(Form_ID));
			form = form[0];
			let Form_Type = form.Form_Type || FormTypes.SingleResponse, // default type is 1 (single response)
				Form_BehaviorOnSave = this.props.Form_BehaviorOnSave || form.Form_BehaviorOnSave,
				Form_RedirectTo =  form.Form_RedirectTo || '',
				Form_CustomValidationSP = form.Form_CustomValidationSP || undefined,
				Form_SaveButton_disable = form.Form_SaveButton_disable || false,
				Form_CancelButton_disable = form.Form_CancelButton_disable || false,
				Form_SaveAndContinueButton_disable = form.Form_SaveAndContinueButton_disable || false,
				Form_SaveAndContinue_RedirectTo = form.Form_SaveAndContinue_RedirectTo || '',
				Form_SaveWithoutRequiredFieldsButton_disable = form.Form_SaveWithoutRequiredFieldsButton_disable || false,
				Custom_Code = form.Custom_Code,
				isValid = Form_CustomValidationSP === undefined;

			// TODO check what the purpose of this is
			let { Form_Name, SurveyMode, PrimaryKey } = this.state;
			if (this.props.location) {
				Form_Name = form.Form_Name || '';
				SurveyMode = true;
				if (this.props.location.state) {
					PrimaryKey = this.props.location.state.PrimaryKey;
				}
				this.setState({ Project_ID });
			}

			let PK_Name = (this.props.history) && (this.props.history.location.state) ? this.props.history.location.state.PK_Name
							: this.props.PK_Name;
			// GET PRELOAD FORM DATA
			// form type 1 (single response) will always preload form data.
			// form type 2 (multiple response) will only preload form data if there is a secondary id value is present.
			const {Form_SecondaryIDValue, Form_SecondaryIDName} = this.state;
			let preloadFormData = [];
			if (Form_Type === FormTypes.SingleResponse ||
				(Form_Type === FormTypes.MultipleResponse && !!Form_SecondaryIDValue)) {
				getFormData(PrimaryKey, Form_ID, Form_SecondaryIDName, Form_SecondaryIDValue)
					.then((response) => {
						if (typeof response.data === "string") throw new Error(response.data);
						else preloadFormData = response.data;
					})
					.catch(e => {
						toaster('error', String(e));
					})
			}

			const { data } = await getFormWidgets(Form_ID, false);
			Widgets = data;

			const isThereQAWidgets = _(Widgets).some(widget => widget.Widget_Type_ID === WidgetTypes.QA),
				isThereIdentifierWidget = _(Widgets).some(widget => widget.Widget_Type_ID === WidgetTypes.Identifier),
				isThereRow = (Widgets).some(widget => widget.Widget_Type_ID === WidgetTypes.Row);

			if (isThereQAWidgets || isThereIdentifierWidget || isThereRow) {
				SurveyMode = true;
			}

			// if there is an identifier, initially hide all other widgets.
			if (isThereIdentifierWidget) {
				Widgets.forEach(w => {
					w.Hidden = true;
					w.disabled = false;
					if(w.Widget_Type_ID === WidgetTypes.Identifier) {
						w.Hidden = false;
					}
					w.key = true;
					return w;
				});
			}
			else {
				Widgets.forEach(w => {
					w.Hidden = false;
					w.disabled = false;
					w.key = true;
					return w;
				});
			}

			// Client Side Validation: get form rules
			let { data: rules} = await getFormClientSideValidation(Form_ID);
			rules.forEach( rule => rule.Conditions = JSON.parse(rule.Conditions));
			this.setState({rules});

			await this.executeCustomCode(Custom_Code, PrimaryKey, Widgets, Form_SecondaryIDValue)

			// disable all QA and Button Widgets if in view only mode
			if(this.state.isViewOnly) {
				Widgets.forEach(w => w.disabled = true);
			}

			this.setState({
				Form_Type,
				Form_BehaviorOnSave,
				Form_RedirectTo,
				Form_CustomValidationSP,
				Form_SaveButton_disable,
				Form_CancelButton_disable,
				Form_SaveAndContinueButton_disable,
				Form_SaveAndContinue_RedirectTo,
				Form_SaveWithoutRequiredFieldsButton_disable,
				Custom_Code,
				isValid,
				Form_Name,
				SurveyMode,
				PrimaryKey,
				Form_ID,
				PK_Name,
				preloadFormData
			})
		}

		//Get all Form Data Elements
		try {
			const { data: DE } = await getFormDataElements(Form_ID);
			this.setState({ dataElements: JSON.parse(DE.dataElements) });
			const { data: DS } = await getDataSources(); //Exec DEs and store results
			let DataSources = DS;
			if (this.state.dataElements.length > 0) {
				let dataElements = this.state.dataElements;
				dataElements.forEach(async function (dataEl, idx) {
					// Institution specific calls
					if (dataEl['jsonParameters'] && dataEl['jsonParameters'].indexOf('@Institution_ID') !== -1) {
						let params = JSON.parse(dataEl['jsonParameters']).map(
							(p) => {
								(p['Name'] === '@Institution_ID') && (p['Default_Value'] = localStorage.getItem('Inst_ID'));
								return p;
							}
						);
						dataEl['jsonParameters'] = JSON.stringify(params);
					}
					var getConn = function (DataSource_ID = this.state.DataSource_ID) {
						const source = DataSources.find((source) => {
							return source.DataSource_ID === DataSource_ID;
						});
						return source.Connection_String;
					}
					dataEl['Connection_String'] = getConn(dataEl.DataSource_ID);
					let { data } = await execGenericSP(dataEl);
					dataElements[idx]['spResult'] = data['data'] ? JSON.parse(data['data']) : [];
				}
				);
				this.setState({ dataElements });
			}
		}
		catch (e) {
			console.error('Error getting form data elements');
		}

		//get all shared info config
		try {
			let { data } = await getInfoConfigShared(Form_ID);
			(typeof data === 'object') && this.setState({ infoConfig: data });
			(typeof data === 'string') && console.error('Error getting Info Config');
			//console.log('data', data)
		}
		catch (e) {
			console.error('Error getting Info Config');
		}

		//Get all QA Widgets per Form
		let widgetsQA = await getFormWidgetQuestionsAnswers(Form_ID).then((response) => response.data);
		widgetsQA && this.setState({ widgetsQA });
		// let Responses = new Array(
		// 	[...new Set(widgetsQA.map((item) => {
		// 			return item["Question_ID"];
		// 		}))
		// 	].filter((r) => r !== undefined).length
		// ).fill().map(() => []);
		// this.setState({Responses})
		//required count

		//console.log('dataElements', this.state.dataElements, this.state.infoConfig, Widgets)
		//Query returns COUNT OF widget IDs for each rowtype widget into withinrow cols
		let enableSave=true
		let Question_Number = 0;
		let subQuestion_Number = 0;
		let infoConfig = this.state.infoConfig, DEs = this.state.dataElements;
		Widgets.forEach(
			function (widget) {
				//('widget.hasSharedDataElement', widget.hasSharedDataElement)
				if (widget.Widget_Type_ID != WidgetTypes.Info && widget.Widget_Type_ID != WidgetTypes.DataTable && widget.Widget_Type_ID != WidgetTypes.DisplayEditInfo && widget.Widget_Type_ID != WidgetTypes.MDHData) {
					let parent_widget_id = 0
					let is_qa_widget_hidden = false
					if (widget.Widget_Type_ID === WidgetTypes.QA && widgetsQA.length > 0) {
						const qa_widget = widgetsQA.filter(w => w.Widget_ID === widget.Widget_ID)[0]
						const parent_id = qa_widget.Parent_Question_Widget_ID
						parent_widget_id = parent_id ? parent_id : 0
						is_qa_widget_hidden = qa_widget.Hide ? qa_widget.Hide : false
					}
					if (!is_qa_widget_hidden) {
						if (parent_widget_id !== 0) {
							widget['Question_Number'] = (Widgets.filter(w => w.Widget_ID === parent_widget_id)[0].Question_Number + 1).toString() + String.fromCharCode(subQuestion_Number + 96)
							subQuestion_Number += 1
						} else {
							widget['Question_Number'] = Question_Number
							Question_Number += (widget.Widget_Type_ID === WidgetTypes.Row && widget['WithinRow'] !== null) ? parseInt(widget['WithinRow']) : 1;
							subQuestion_Number = 1
						}
					}
				}
				if (widget.Widget_Type_ID == WidgetTypes.Tabs) {
					enableSave = false
				}
				//if has shared DEs, attach the results to widgets
				if (widget.hasSharedDataElement > 0) {
					if (widget.Widget_Type_ID === WidgetTypes.Info) {
						let resultSource = infoConfig.filter((infoEL)=>infoEL.Widget_ID === widget.Widget_ID)[0],
							destDE = DEs.filter((deEl)=> deEl.ResultSource_Content === resultSource['ResultSource_Content']);
							widget['hasSharedDataElement'] = destDE || 0;
							widget['resultSource'] = resultSource;
					}
				}
			}
		);

		//CHECK ITS PURPOSE
		// Widgets = Widgets.filter((w) => !w.WithinRow).map((w) => ({
		// 	...w,
		// 	Skipped: false,
		// }));

		const { history } = this.props 
		this.setState({
			Widgets,
			enableSave,
			defaultRender: true,
			loading: false
		});

		const DataTableWidget = Widgets.find((obj) => obj.Widget_Type_ID === WidgetTypes.DataTable);
		if (DataTableWidget) {
			const { data } = await getDT(DataTableWidget.Widget_ID);
			const ParametersList = JSON.parse(data.Parameters);
			const FilterParametersList = ParametersList.map((obj) => ({ ...obj, Value: obj.Default_Value }));
			this.setState({ ParametersList, FilterParametersList });
		}

		logActivity(window.location.href.substring(window.location.origin.length),
			'FORMVIEWER',this.state.PrimaryKey, this.state.Form_ID);
	}

	async executeCustomCode(Custom_Code, PrimaryKey, Widgets, Form_SecondaryIDValue) {
		if (!isNullOrEmpty(Custom_Code)) {
			console.log("Executing Custom Code: " + Custom_Code);
			try {
				let functions = {getRandomizedResultFullScale, executeSP};
				const AsyncFunction = new Function(`return Object.getPrototypeOf(async function(){}).constructor`)();
				const customFunction = new AsyncFunction('PrimaryKey', 'SecondaryID', 'Widgets', 'functions', Custom_Code, );
				await customFunction(PrimaryKey, Form_SecondaryIDValue, Widgets, functions);
			} catch (error) {
				console.error('Error executing code:', error);
			}
		}
	}

	updateQuestionSequence(response) {
		if (Object.keys(response.Responses).length !== 0) {
			let questionSequence = [...this.state.questionSequence], delIdx = (this.state.questionSequence).indexOf(response['Responses'][0]['Question_ID']);
			(delIdx !== -1) && questionSequence.splice(delIdx, 1);
			questionSequence.push(response['Responses'][0]['Question_ID']);
			this.setState({ questionSequence });
			//console.log('b4 Response', delIdx, response['Responses'][0]['Question_ID'], this.state.questionSequence);
		}
	}

	/**
	 * Client Side Validation
	 * @param {*} condition 
	 */
	checkRuleCondition = (condition) => {
		const { Widget_ID, Question_Type_ID, Question_ID, Answer_ID, Answer_Text, ConditionOperator,
			Matrix_Question_ID, Matrix_Question_Type_ID, Matrix_Question_Text, Target_Widget_ID, CompareWidget, CheckIfRandomized, IsRandomized } = condition;
		// If the condition is to check randomization status
		if (CheckIfRandomized) {
			// Get participant randomization status
			// let {data} = await getRandomizedResultFullScale(this.state.PrimaryKey)
			if (IsRandomized === 1 && this.state.isParticipantRandomized) {
				return true
			} else if (IsRandomized === 0 && !this.state.isParticipantRandomized) {
				return true
			}
			return false
		} else {
		
		let widgetResponses = Object.values(this.state.Responses).find(r => r.Widget_ID === Widget_ID);
		if(!widgetResponses) return false;
		widgetResponses = widgetResponses.Responses;

		if ([
				QuestionTypes.Multiple_Choice,
				QuestionTypes.Scale
			].includes(Question_Type_ID)) {
			//return widgetResponses.some(q => q.Question_ID === Question_ID && q.Answer_ID === Answer_ID && q.Answer_Text.length > 0);
			// check if answer text is in response answer_text array
			if(widgetResponses.length > 0) {
				let answerText = widgetResponses[0].Answer_Text;
				// answerText may be a string or array - we need to restructure Multiple Choice later
				if (answerText) {
					if (typeof answerText === 'string') {
						answerText = JSON.parse(answerText);
					}
					if (Array.isArray(answerText) && answerText.length > 0) {
						let isSelected = answerText.map(a => stripTags(a)).includes(Answer_Text);
						return ConditionOperator === 'is Selected' ? isSelected : !isSelected;
					}
				}
			}
			return ConditionOperator === 'is Not Selected';

		}
		else if ([
				QuestionTypes.Dropdown,
				QuestionTypes.Picklist,
				QuestionTypes.Institution
		].includes(Question_Type_ID)) {
			let isSelected = widgetResponses.some(q => q.Question_ID === Question_ID && q.Answer_ID === Answer_ID);
			return ConditionOperator === 'is Selected' ? isSelected : !isSelected;
		}
		else if ([
				QuestionTypes.Text,
				QuestionTypes.Numeric,
				QuestionTypes.Numeric_Tally,
				QuestionTypes.Date,
				QuestionTypes.Time,
				QuestionTypes.Identifier,
				QuestionTypes.Textarea
		  	].includes(Question_Type_ID)) {
			let response = widgetResponses.find(q => q.Question_ID === Question_ID)
			if(!response) return false;
			let responseAnswerText = response.Answer_Text ? stripTags(response.Answer_Text) : null;
			
			let targetResponseAnswerText = null
			if (CompareWidget) {
				let targetWidgetResponses = Object.values(this.state.Responses).find(r => r.Widget_ID === Target_Widget_ID);
				if(!targetWidgetResponses) return false;
				targetWidgetResponses = targetWidgetResponses.Responses;
				targetResponseAnswerText = targetWidgetResponses[0].Answer_Text ? stripTags(targetWidgetResponses[0].Answer_Text) : null;
			}

			if (['Equals', 'Less Than', 'Larger Than'].includes(ConditionOperator) && CompareWidget && 
				(isNullOrEmpty(targetResponseAnswerText)|| isNullOrEmpty(responseAnswerText))) {
					return false
			}

			switch (ConditionOperator) {
				case 'Equals':
					return CompareWidget ? targetResponseAnswerText === responseAnswerText : Answer_Text === responseAnswerText;
				case 'is Empty':
					return isNullOrEmpty(responseAnswerText);
				case 'is Not Empty':
					return !isNullOrEmpty(responseAnswerText);
				case 'Less Than':
					return CompareWidget ? responseAnswerText < targetResponseAnswerText : responseAnswerText < Answer_Text;
				case 'Larger Than':
					return CompareWidget ? responseAnswerText > targetResponseAnswerText : responseAnswerText > Answer_Text;
				default:
					return false;
			}
		}
		else if (Question_Type_ID === QuestionTypes.Matrix) {
			// return widgetResponses.some(q => q.Question_ID === Matrix_Question_ID && q.Answer_ID === Answer_ID);
			let response = widgetResponses.find(r => r.Question_ID === Matrix_Question_ID);
			if (response && response.Answer_Text) {
				let isSelected = response.Answer_Text.split(',').includes(Answer_Text);
				return ConditionOperator === 'is Selected' ? isSelected : !isSelected;
			}
			return ConditionOperator === 'is Not Selected';
		}
		else if (Question_Type_ID === QuestionTypes.Checkbox) {
			let response = widgetResponses.find(q => q.Question_ID === Question_ID);
			if (ConditionOperator === 'is Checked') {
				return response.Answer_ID && response.Answer_Text;
			}
			else {
				return !response.Answer_ID || !response.Answer_Text;
			}
		}
		return false;
	}
	};

	/**
	 * Client Side Validation
	 * Update Widget.Hidden to be true or false if conditions of a rule are met
	 * All rules must have at least one condition - this should be checked in form builder before save
	 * @param {int} Widget_ID optional - check only rules with conditions involving this Widget_ID
	 */
	checkRules = (Widget_ID = null) => {
		const rules = Widget_ID 
			? this.state.rules.filter(rule => rule.Conditions.some(condition => condition.Widget_ID === Widget_ID))
			: this.state.rules;
		let Widgets = [...this.state.Widgets];
		let Responses = this.state.Responses
		rules.forEach((rule) => {
			// check rule conditions are met
			let ruleResult = false;
			if (rule.RuleOperator === 'And') {
				ruleResult = true;
				for (const condition of rule.Conditions) {
					if(!this.checkRuleCondition(condition)) {
						ruleResult = false;
						break;
					}
				}
			}
			else if (rule.RuleOperator === 'Or') {
				for (const condition of rule.Conditions) {
					if(this.checkRuleCondition(condition)) {
						ruleResult = true;
						break;
					}
				}
			}

			// set Widget.Hidden based on rule action and whether rule conditions were met
			if (rule.RuleAction === 'Show') {
				let w = Widgets.find(w  => w.Widget_ID === rule.Widget_ID)
				if (!w) {
					w = Widgets.find(w => (w.Columns && w.Columns.includes(rule.Widget_ID)))
					if (ruleResult) {
						if (w && w.columnsHidden && w.columnsHidden.includes(rule.Widget_ID))
						{
							w.columnsHidden = w.columnsHidden.filter(item => item !== rule.Widget_ID)
						}
					} else {
						w && (w.columnsHidden = w.columnsHidden ? [...w.columnsHidden, rule.Widget_ID] : [rule.Widget_ID])
					}
				} else {
					w.Hidden = !ruleResult
				}
				// Widgets.find(w  => w.Widget_ID === rule.Widget_ID).Hidden = !ruleResult;
			} else if (rule.RuleAction === 'Hide') {
				let w = Widgets.find(w  => w.Widget_ID === rule.Widget_ID)
				if (!w) {
					w = Widgets.find(w => (w.Columns && w.Columns.includes(rule.Widget_ID)))
					if (ruleResult) {
						w && (w.columnsHidden = w.columnsHidden ? [...w.columnsHidden, rule.Widget_ID] : [rule.Widget_ID])
					} else {
						if (w && w.columnsHidden && w.columnsHidden.includes(rule.Widget_ID))
						{
							w.columnsHidden = w.columnsHidden.filter(item => item !== rule.Widget_ID)
						}
					}
				} else {
					w.Hidden = ruleResult
				}
				// Widgets.find(w  => w.Widget_ID === rule.Widget_ID).Hidden = ruleResult;
			} else if (rule.RuleAction === 'Clear' && ruleResult) {
				let resp = Object.values(Responses).find(r => r.Widget_ID === rule.Widget_ID)
				if (resp) {
					resp.Responses[0].Answer_Text = '' 
					this.setState({ Responses })
					this.setState({refreshWidget: true})
				}
			} else if (rule.RuleAction === 'Alert') {
				// let Question_Text = stripTags(this.state.widgetsQA.filter(w => w.Widget_ID === Widget_ID)[0].Question_Text)
				let allowSavingForm = this.state.allowSavingForm
				if (ruleResult) {
					allowSavingForm[Widget_ID] = rule.AllowSave
					this.setState({ 
						showWarningModal: true, 
						warningModalMessage: rule.AlertMessage,
						allowSavingForm: allowSavingForm,
						alertMessages: new Set([...Array.from(this.state.alertMessages), rule.AlertMessage])
					})
				} else {
					let alertMessages = this.state.alertMessages
					if (alertMessages.size > 0 || alertMessages.length > 0) {
						alertMessages.delete(rule.AlertMessage)
					}
					allowSavingForm[Widget_ID] = true
					this.setState({ 
						allowSavingForm: allowSavingForm,
						alertMessages
					})
				}
				
			}
		})
		this.setState({Widgets});
	};

	handleRefreshWidget = () => {
		this.setState({refreshWidget: !this.state.refreshWidget})
	}

	handleResponse = (idx, Response) => {
		let Widgets = [...this.state.Widgets];
		//check skip logic	
		if (Response !== undefined && 'Skip' in Response) {
			Widgets = Widgets.map((w) => {
				let temp = w;
				temp.Skipped = Response.Skip == null ? false : !!Response.Skip.includes(w.Widget_ID);
				return temp;
			});
			this.setState({ Widgets });
		}

		// if the response is from the identifier widget, show previously hidden widgets and update primary key
		// Client side validation should get checked after this.
		if (Response !== undefined && 'Identifier' in Response && !isNullOrEmpty(Response.Identifier)) {
			Widgets.forEach(w => w.Hidden = false);
			this.setState({ PrimaryKey: Response.Identifier, Widgets });
		}
		let Responses = this.state.Responses;
		if(Response !== undefined && Response.Responses) {
			if( Response.Responses.length > 0 && !('Identifier' in Response) && Response.Responses[0].Question_ID) {
				Response.Widget_ID = this.state.widgetsQA.find(
					w => w.Question_ID === Response.Responses[0].Question_ID
				).Widget_ID;
			}
			Responses[idx] = Response;
			this.setState({ Responses });

			// if this form has client side validation rules, check on rules to update which widgets to show/hide
			if(this.state.rules.length > 0) {
				this.checkRules(Response.Widget_ID);
			}
		}

		//console.log('Response: ', idx, Response['Responses'])
		Response['Responses'] && this.updateQuestionSequence(Response);
	};

	updateRowColumns = (Widget_ID, Columns) => {
		let columnWidgetIDs = []
		Columns.forEach(c => {
			columnWidgetIDs.push(c.Column_Widget_ID)
		})
		let widgets = this.state.Widgets
		let widget = widgets.find(w => (w.Widget_ID === Widget_ID))
		widget.Columns = columnWidgetIDs
		this.setState({Widgets: widgets})
	}

	getResponsesToSave = () => {
		let to_save = [], Widgets = this.state.Widgets, questionSequence = this.state.questionSequence;
		// console.log(this.state.Responses)
		Object.values(this.state.Responses).forEach(function (res) {
			let response = res;
			response.Responses && response.Responses[0] && 
				(response['Responses'][0]['Question_Seq'] = questionSequence.indexOf(response.Responses[0]['Question_ID']) >= 0 ? (questionSequence.indexOf(response.Responses[0]['Question_ID'])+1) : 0);
			if (response.Response_Required && response.Responses.length === 0) {
				// to_save = [];
				return;
			} else if (response.Responses && response.Responses.length > 0) {
				if (typeof response['Responses'][0]['Answer_Text'] === 'object' && (response['Responses'][0]['Answer_Text'] == null || response['Responses'][0]['Answer_Text'].length === 0)) {
					return;
				}
				//clear up hidden fields from save response
				let w = Widgets.find(w => (w.Widget_ID === response.Widget_ID)) || undefined;
				if (!w) {
					w = Widgets.find(w => (w.Columns && w.Columns.includes(response.Widget_ID))) || undefined
				}
				//Clean up (ignore) Checkbox unchecked answers
				if (w && w.Question_Type_ID === QuestionTypes.Checkbox && response['Responses'][0]['Answer_Text'] === false) {
					return;
				}
				response.Responses.forEach(r => r.isValidAnswer = response.isValidAnswer ?? true);
				if (!w || !w.Hidden) {
					to_save = [...to_save, ...response.Responses];
				}
			}
		});
		if ((this.state.PrimaryKey!==null && this.state.PK_Name)) {
			to_save = [...to_save];
		}
		to_save = to_save.filter((resp) => { return (resp.Answer_Text != null || resp.Answer_ID != null);});
		
		return to_save;
	};

	serverSideValidation = async (to_save) => {
		let validationError = 'Server Side Validation Failed'
		if (this.state.Form_CustomValidationSP) {
			// call the validation api and set isValid
			try {
				let { data: validationResponse } = await customValidateForm(this.state.Form_ID, this.state.PrimaryKey, to_save, this.state.Form_CustomValidationSP, this.state.Form_SecondaryIDValue);

				// String: error in validation, 0: no error
				if (typeof validationResponse === 'string') {
					this.setState({
						showWarningModal: true,
						warningModalMessage: validationResponse
					})
					validationError = validationResponse
					return 'stop';
				} else {
					this.setState({ isValid: true })
				}
			}
			catch (e) {
				console.error('Error while performing Server Validation: ', e)
				this.setState({ isValid: false })
			}
		}

		if (!this.state.isValid) {
			toaster('warning', validationError);
			return false;
		}

		let isValidRequiredFieldsCount = true;

		// If Q1 in Approach Screening is No, no need to check for required fields
		let checkRequiredFields = true
		if (this.state.Form_ID === 48) {
			const Q1_QuestionID = this.state.widgetsQA.filter(q => q['Widget_ID'] === 890)[0]['Question_ID']
			let answerText = to_save.filter(r => r['Question_ID'] === Q1_QuestionID)[0]['Answer_Text']
			if (typeof answerText === 'string') {
				answerText = JSON.parse(answerText)
			}
			if (Array.isArray(answerText) && answerText.length > 0) {
				answerText = answerText.map(a => stripTags(a))
				if (answerText.includes('No')) {
					checkRequiredFields = false
				}
			}
		} 
		
		if (checkRequiredFields) {
			(this.state.widgetsQA).forEach((item) => {
				if (item.WithinRow && item.Response_Required) {
					if ((to_save.filter((r) => r['Question_ID'] === item['Question_ID'])).length === 0) {
						isValidRequiredFieldsCount = false;
						return;
					}
				}
				let w = this.state.Widgets.filter((w) => w.Widget_ID === item['Widget_ID'])[0] || undefined;
				if (item['Response_Required'] === true && w !== undefined && !w.Hidden)
				{
					if ((to_save.filter((r) => r['Question_ID'] === item['Question_ID'])).length === 0) {
						isValidRequiredFieldsCount = false;
						return;
					}
				}
			});
		}
		if (!isValidRequiredFieldsCount) {
			toaster('warning', 'Please make sure to enter data for all required fields!');
			return false;
		}
		return true;
	};

	/**
	 * Re-mount the specified widget
	 * @param widgetId int
	 */
	remountWidget(widgetId) {
		let Widgets = this.state.Widgets.map(w => {
			if (w.Widget_ID === widgetId) {
				w.key = !w.key
			}
			return w;
		});
		this.setState({Widgets});
	}

	/**
	 * Add MDH widget information to mdhUpdateWidgets state.
	 * Pass this as prop to MDHDataViewer. Once MDHDataViewer successfully gets participant info, it'll call this func
	 * @param mdhWidgetId int
	 * @param mdhProjectId string
	 * @param fieldsToUpdate array of strings. Only includes fields that have no data in MDH
	 * @param updateQuestionWidgetId int. widget id of question to get answer from and update field(s) in MDH with
	 */
	updateFormMDH = (mdhWidgetId, mdhProjectId, fieldsToUpdate, updateQuestionWidgetId) => {
		let mdhUpdateWidgets = [...this.state.mdhUpdateWidgets];
		mdhUpdateWidgets.push({mdhWidgetId, mdhProjectId, fieldsToUpdate, updateQuestionWidgetId});
		this.setState({mdhUpdateWidgets});
	}

	/**
	 * For each mdh widget that has fields to be updated,
	 * Combine and format fields with the value it will be updated with
	 * ex: [field1, demographics.field2, demographics.field3] to
	 *     {field1: value, demographics: {field2: value, field3: value}}
	 * Then call MDH update endpoint and refresh MDH widget
	 */
	updateMDHFields = () => {
		const { mdhUpdateWidgets, Responses } =  this.state;
		mdhUpdateWidgets.map(mdhWidget => {
			let value = Object.values(Responses).find(r => r.Widget_ID === mdhWidget.updateQuestionWidgetId).Responses[0].Answer_Text;
			console.log('value', value);
			let formattedFields = {};
			mdhWidget.fieldsToUpdate.forEach(f => {
				if (f.includes('.')) {
					const [parentKey, fieldName] = f.split('.');
					if(!formattedFields[parentKey]) {
						formattedFields[parentKey] = {}
					}
					formattedFields[parentKey][fieldName] = value;
				}
				else {
					formattedFields[f] = value;
				}
			})
			let data = Object.assign({}, {participantIdentifier: this.state.PrimaryKey}, formattedFields);
			console.log(data)

			// Make request to mdh api to update those fields
			updateMDHParticipantInfo(mdhWidget.mdhProjectId, data)
				.then(response => {
					if(!response.data.includes('Error')) {
						toaster('success', 'Updated MDH fields');
						logActivity(window.location.href.substring(window.location.origin.length),
							'UPDATE_MDH_INFO_SUCCESS', this.state.PrimaryKey, this.state.Form_ID, data);

						// remount MDH widget
						this.remountWidget(mdhWidget.mdhWidgetId);

					}
					else {
						throw new Error(response)
					}
				})
				.catch(e => {
					console.log(e);
					toaster('error', 'Error updating MDH fields');
					logActivity(window.location.href.substring(window.location.origin.length),
						'UPDATE_MDH_INFO_FAILED', this.state.PrimaryKey, this.state.Form_ID, e);
				});
		});
		this.setState({mdhUpdateWidgets: []}); // clear to prevent more updates
	}

	saveSurveyResponseWithMDH = (MDHAPIResult, updateQuestionWidgetID, Project_ID, Form_ID, PrimaryKey) => {
		saveSurveyResponseWithMDH(updateQuestionWidgetID, Project_ID, Form_ID, PrimaryKey, MDHAPIResult.toString())
		.then(response => {
			if (response.data.includes("Error")) {
				toaster('error', response.data)
			} 
			else if (response.data.includes("successfully")) {
				const Question_ID = this.state.widgetsQA.find(
					w => w.Widget_ID === updateQuestionWidgetID
				).Question_ID;
				let Answer_Text = MDHAPIResult.toString()
				this.handleResponse(Object.keys(this.state.Responses).length, {
					Responses: [{
						Answer_ID: null,
						Answer_Text: Answer_Text,
						Question_ID: Question_ID,
						Question_Number: Object.keys(this.state.Responses).length
					}],
					Widget_ID: updateQuestionWidgetID,
					Response_Required: false,
					Question_Number: Object.keys(this.state.Responses).length
				})
			}
		})
	}
	
	handleSaveResponse = async (saveAndContinue=false) => {
		if (Object.values(this.state.allowSavingForm).some(v => !v)) {
			this.setState({ 
				showWarningModal: true, 
				warningModalMessage: Array.from(this.state.alertMessages).join(', ')
			})
			return
		}
		let to_save = this.getResponsesToSave();

		// Show alert and prevent saving for dates that require a valid response
		const { widgetsQA } = this.state;
		let questionsToValidate = widgetsQA.filter(w => w.Prevent_Save_Invalid ?? 0 === 1);
		let invalidResponses = questionsToValidate.map(q => {
			let resp = to_save.find(r => q.Question_ID === r.Question_ID);
			resp.Question_Text = stripTags(q.Question_Text)
			return resp
		}).filter(r => r != null && r.isValidAnswer === false);
		if (invalidResponses.length > 0) {
			let message = invalidResponses.map(q => q.Question_Text).join(', ');
			this.setState({
				showWarningModal: true,
				warningModalMessage: 'Please check the following question(s) for accuracy: ' + message
			});
			return;
		}

		let validationResult = await this.serverSideValidation(to_save);
		let Form_SaveWithoutRequiredFieldsButton_disable = this.state.Form_SaveWithoutRequiredFieldsButton_disable
		if (Form_SaveWithoutRequiredFieldsButton_disable && !validationResult) {
			return;
		}
		if (validationResult === 'stop') {
			return;
		}
		// console.log(to_save)
		const { data } = await saveResponse(this.state.Project_ID, this.state.Form_ID, this.state.PrimaryKey,
			this.state.Form_SecondaryIDName, this.state.Form_SecondaryIDValue, to_save);
		if (data.includes('Error')) {
			toaster('error', data);
			logActivity(window.location.href.substring(window.location.origin.length),
				'FORMVIEWER_SAVE_FAILED', this.state.PrimaryKey, this.state.Form_ID);
		} else {
			toaster('success', 'Form Saved');
			logActivity(window.location.href.substring(window.location.origin.length),
				'FORMVIEWER_SAVE_SUCCESS',this.state.PrimaryKey, this.state.Form_ID);

			// update fields in MDH if there are any MDH widgets with fields that need updating
			await this.updateMDHFields()

			if (this.state.isTab) {
				await this.props.updateTabStatuses();
			}

			if(saveAndContinue) {
				this.props.changeTab(this.state.Form_SaveAndContinue_RedirectTo);
				if (parseInt(this.state.Form_BehaviorOnSave) === 3) { //Reload Page
					window.location.reload();
				}
			}
			else {
				//Form Save Action
				if (parseInt(this.state.Form_BehaviorOnSave) === 1 && !this.state.isTab) { //Redirect Form
					window.location = BASE_URL + `form?form_id=${this.state.Form_RedirectTo}&project_id=${this.state.Project_ID}&pk=${this.state.PrimaryKey}&inst_id=${this.state.selectedInst}`
				}
				else if (parseInt(this.state.Form_BehaviorOnSave) === 2) { //Clear Form
					this.setState({ clearForm: true });
					this.reloadForm();
				}
				else if (parseInt(this.state.Form_BehaviorOnSave) === 3) { //Reload Page
					window.location.reload();
				}
				if (this.state.Form_Type === FormTypes.MultipleResponse && parseInt(this.state.Form_BehaviorOnSave) === 2) {
					this.setState({ Form_SecondaryIDValue: 0, Form_SecondaryIDName: '' })
				} else {
					const returned_sk_value = parseInt(data.split(", ")[0])
					const returned_sk_name = data.split(", ")[1]
					if( typeof returned_sk_value === 'number' && returned_sk_value > 0) {
						this.setState({ Form_SecondaryIDValue: returned_sk_value, Form_SecondaryIDName: returned_sk_name });
						return returned_sk_value;
					}
				}
			}

		}
		return 0;
	};

	handleCancel() {
		(this.state.isTab || this.state.isPopUp) ?
			((this.state.rulesObj.length > 0 || this.state.Form_ID === Custom_Forms.addAeSaeEvent) ? window.location.reload() : this.reloadForm())
			: (window.location = BASE_URL + 'projectViewer?project_id=' + this.state.Project_ID);
	}

	handleFilterParameters = (FilterParametersList) => {
		this.setState({ FilterParametersList });
	};

	// passed down to Button so it can reload the form after pop up close
	reloadForm = async () => {
		await this.executeCustomCode(this.state.Custom_Code, this.state.PrimaryKey, this.state.Widgets)

		let Widgets = this.state.Widgets.map(w => {
			w.key = !w.key
			return w;
		})
		this.setState({Widgets});
	}

	handleClose = () => {
		this.setState({ showWarningModal: false })
	}

	render() {
		const { Form_ID, Form_BehaviorOnLoad, Form_BehaviorOnSave, Form_SecondaryIDName, Form_SecondaryIDValue, SurveyMode, LightMode, PrimaryKey, PK_Name, Project_ID, FilterParametersList, Widgets, enableSave, isTab, preloadFormData, dataElements, infoConfig, isPopUp} = this.state;
		if (this.state.loading) {
			return <CustomLoader loading={this.state.loading} />;
		}

		if (Form_ID < 0) {
			return (
				<div className='container'>
					<div className='alert alert-danger' role='alert'>
						{Form_ID === -2 && 'No form exists.'}
						{Form_ID === -1 && 'Not valid entry to access form.'}
					</div>
				</div>
			);
		}
		return (
			<React.Fragment>
				{this.state.SurveyMode && (
					<React.Fragment>
						{
							PrimaryKey && !isTab && !isPopUp &&
							<header className='page-header page-header-dark bg-gradient-primary-to-secondary'>
								<div className='container'>
									<div className='page-header-content pt-4'>
										<div className='row align-items-center justify-content-between'>
											<div className='col-auto mt-4'>
												<h1 className='page-header-title'>
													<div className='page-header-icon'>
														<i data-feather='file'></i>
													</div>
													{this.state.Form_Name}
												</h1>
											</div>
											<div className='col-12 col-xl-auto mt-4'>Primary Key(Test field): {this.state.PrimaryKey}</div>
										</div>
									</div>
								</div>
							</header>
						}
						{
							!PrimaryKey && <div className=' pb-5'></div>
						}
						<div className='container mt-n4'>
							<div className={!isPopUp && !isTab ? 'card': ''}>
								<div className='card-body'>
									<div className={!isPopUp && !isTab ?'sbp-preview' : ''}>
										<div className='sbp-preview-content'>
											{Widgets.map((widget, idx) => (
												<div hidden={widget.Hidden} key={'V' + widget.Widget_ID}>
													{
													(this.state.defaultRender || this.state.clearForm) &&
													<WidgetViewer
														Widget={widget}
														Form_ID={Form_ID}
														Form_BehaviorOnLoad={Form_BehaviorOnLoad}
														Form_BehaviorOnSave={Form_BehaviorOnSave}
														Question_Number={widget.Question_Number}
														OnUpdate={this.handleResponse}
														SurveyMode={SurveyMode}
														PrimaryKey={PrimaryKey}
														PK_Name={PK_Name}
														Project_ID={Project_ID}
														LightMode={LightMode}
														FilterParametersList={FilterParametersList}
														onSubmitFilterParameters={this.handleFilterParameters}
														key={widget.key}
														selectedInstitution={this.state.selectedInst}
														Response={this.state.Responses}
														Form_SecondaryIDName={Form_SecondaryIDName}
														Form_SecondaryIDValue={Form_SecondaryIDValue}
														Custom_Save={this.handleSaveResponse}
														widgetsQA={this.state.widgetsQA}
														preloadFormData={preloadFormData}
														dataElements={dataElements}
														infoConfig={infoConfig}
														sharedDataElement={widget.hasSharedDataElement}
														resultSource={widget.resultSource}
														source={this.props.source}
														reloadForm={this.reloadForm}
														closePopUpForm={this.props.closePopUpForm ? this.props.closePopUpForm : undefined}
														disabled={widget.disabled}
														refreshWidget={this.state.refreshWidget}
														handleRefreshWidget={this.handleRefreshWidget}
														FormWidgets={Widgets}
														updateFormMDH={this.updateFormMDH}
														saveSurveyResponseWithMDH={this.saveSurveyResponseWithMDH}
														updateRowColumns={this.updateRowColumns}
													/>
												}
												</div>
											))}
										</div>
									</div>
									{enableSave && (
										<div className='d-flex justify-content-center mt-1'>
											{!(this.state.Form_SaveButton_disable === 'True') && (<button className='btn btn-primary rounded-0' onClick={() => this.handleSaveResponse()}>
												Save
											</button>)}
											{!(this.state.Form_SaveAndContinueButton_disable === 'True') && this.state.isTab && (
												<button className='btn btn btn-purple rounded-0 ml-2' onClick={() => this.handleSaveResponse(true)}>
													Save and Continue
												</button>
											)}
											{!(this.state.Form_CancelButton_disable === 'True') && (<button className='btn btn btn-outline-danger rounded-0 ml-2' onClick={this.handleCancel}>
												Cancel
											</button>
											)}
										</div>
									)}
									{Form_ID === Custom_Forms.addAeSaeEvent && !enableSave && (
										<div className='d-flex justify-content-center mt-1'>
											<button className='btn btn btn-outline-danger rounded-0 ml-2' onClick={this.handleCancel}>
												Cancel
											</button>
										</div>
									)}
								</div>
							</div>
						</div>
					</React.Fragment>
				)}

				{!this.state.SurveyMode && (
					<React.Fragment>
						{this.state.Widgets.map((widget, idx) => (
							<div hidden={widget.Hidden} key={'viewerWidget' + widget.Widget_ID}>
								<WidgetViewer
									Widget={widget}
									Form_ID={Form_ID}
									Form_BehaviorOnLoad={Form_BehaviorOnLoad}
									Form_BehaviorOnSave={Form_BehaviorOnSave}
									Question_Number={(widget.Widget_Type_ID !== WidgetTypes.Info || widget.Widget_Type_ID !== WidgetTypes.Button || widget.Widget_Type_ID !== WidgetTypes.DisplayEditInfo ) ? widget.Question_Number : ''}
									OnUpdate={this.handleResponse}
									SurveyMode={SurveyMode}
									PrimaryKey={PrimaryKey}
									PK_Name={PK_Name}
									Project_ID={Project_ID}
									LightMode={LightMode}
									FilterParametersList={FilterParametersList}
									onSubmitFilterParameters={this.handleFilterParameters}
									key={widget.key}
									selectedInstitution={this.state.selectedInst}
									Responses={this.props.Responses}
									Form_SecondaryIDName={Form_SecondaryIDName}
									Form_SecondaryIDValue={Form_SecondaryIDValue}
									Custom_Save={this.handleSaveResponse}
									widgetsQA={this.state.widgetsQA}
									preloadFormData={preloadFormData}
									dataElements={dataElements}
									infoConfig={infoConfig}
									sharedDataElement={widget.hasSharedDataElement}
									resultSource={widget.resultSource}
									source={this.props.source}
									reloadForm={this.reloadForm}
									closePopUpForm={this.props.closePopUpForm ? this.props.closePopUpForm : undefined}
									FormWidgets={Widgets}
									updateFormMDH={this.updateFormMDH}
									updateRowColumns={this.updateRowColumns}
								/>
							</div>
						))}
					</React.Fragment>
				)}
				{this.state.SurveyMode && <ScrollButton />}
				<ErrorPopup 
					title='Warning'
					message={this.state.warningModalMessage} 
					open={this.state.showWarningModal} 
					onClose={this.handleClose}
				/>
			</React.Fragment>
		);
	}
}

export default FormViewer;